import { getUserToken } from "../helpers/authHelper";
import api from "../api";

// Job Modul
export async function GetVacancyTypeList(lang_id = 1) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/vacancyType/get-vacancytype/`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-lang_id": lang_id || 1,
    },
  });
}
